import { render, staticRenderFns } from "./campaignTableTip.vue?vue&type=template&id=1485df24&scoped=true"
import script from "./campaignTableTip.vue?vue&type=script&lang=js"
export * from "./campaignTableTip.vue?vue&type=script&lang=js"
import style0 from "./campaignTableTip.vue?vue&type=style&index=0&id=1485df24&lang=less&scoped=true"
import style1 from "./campaignTableTip.vue?vue&type=style&index=1&id=1485df24&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485df24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1485df24')) {
      api.createRecord('1485df24', component.options)
    } else {
      api.reload('1485df24', component.options)
    }
    module.hot.accept("./campaignTableTip.vue?vue&type=template&id=1485df24&scoped=true", function () {
      api.rerender('1485df24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hr/recruiter/component/campaignTableTip.vue"
export default component.exports